import { api } from '@owl-nest/api-client/latest'
import { type ApiResponse } from '@owl-nest/api-client'
import * as model from '@owl-nest/models'

export async function query(
  projectId: number,
  authenticated: boolean,
  projectToken?: string,
): Promise<ApiResponse<model.impact.Impact>> {
  const getParams: Record<string, string> = {}
  if (projectToken) {
    getParams['token'] = projectToken
  }

  const response = await api.get.projectImpact({
    urlParams: { projectId: String(projectId) },
    withToken: authenticated,
    getParams,
  })

  return response.next((response) => model.impact.model(response.body))
}
